import { render, staticRenderFns } from "./FootMarket.vue?vue&type=template&id=b6f2acce"
import script from "./FootMarket.vue?vue&type=script&lang=js"
export * from "./FootMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports